'use client';

import { useSelector } from 'react-redux';
import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import LLAlert from '@next-app/components/elements/LLAlert/LLAlert';
import {
  selectPaymentsInfo,
  selectIsCheckoutDetailsLoaded,
  selectIsEmailDeliveryItemInCart,
  selectDisablePaymentList,
  selectIsGiftCardItemInOrder,
  selectIsPaymentMethodStep,
  selectCheckoutState,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import GiftCardContainer from '../GiftCardContainer/GiftCardContainer';
import { isNotNullOrUndefinedorEmpty } from '@next-app/utils/common-utils';
import parse from 'html-react-parser';

const GiftCardSection = () => {
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const IsEmailDeliveryItemInCart = useSelector(
    selectIsEmailDeliveryItemInCart,
  );
  const isGiftCardItemInOrder = useSelector(selectIsGiftCardItemInOrder);
  const { isGiftCertificateOverTotal } = useSelector(selectPaymentsInfo) || {};
  const disablePaymentList = useSelector(selectDisablePaymentList);
  const isPaymentMethodStep = useSelector(selectIsPaymentMethodStep);
  const { submitError = '' } = useSelector(selectCheckoutState);
  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional
        if={isNotNullOrUndefinedorEmpty(submitError) && isPaymentMethodStep}
      >
        <LLAlert type="danger">
          <p dangerouslySetInnerHTML={{ __html: parse(submitError) }}></p>
        </LLAlert>
      </Conditional>
      <Conditional
        if={
          !IsEmailDeliveryItemInCart &&
          !isGiftCardItemInOrder &&
          isPaymentMethodStep
        }
      >
        <>
          <Conditional if={isGiftCertificateOverTotal || disablePaymentList}>
            <LLAlert type="warning">
              You have covered your balance. No additional payment method is
              required.
            </LLAlert>
          </Conditional>
          <GiftCardContainer />
        </>
      </Conditional>
    </>
  );
};

export default GiftCardSection;
